import { ITelemetryNamespaceLogger } from '@fluidx/office-fluid-types';
import { ActivityTracker, getDocumentHiddenResult, isDevToolEverOpenedInCurrentWindow } from '@fluidx/utilities';
import { OWHAshaErrorType, OWHAshaPillar, OWHAshaVeto } from '../../Reliability/OfficeWebHostAsha';
import { logQoSError } from '../../Reliability/QoSErrorHelpers';
import { Activity } from '../../Telemetry';

export function handleIframeLoadFailure({
  reject,
  bootIframeActivityTracker,
  loadComponentActivityTracker,
  documentHiddenTrackerId,
  logger
}: {
  reject: (reason?: any) => void;
  bootIframeActivityTracker: ActivityTracker;
  loadComponentActivityTracker: ActivityTracker;
  documentHiddenTrackerId: number;
  logger?: ITelemetryNamespaceLogger;
}): void {
  const error = new Error('Timed out while loading iframe');
  // Error text will be either "Timed out while loading iframe" or "Timed out while loading sourceless iframe"
  // (Putting this note here so that developers can search for the full error string and find it)

  bootIframeActivityTracker.setResult(false);
  loadComponentActivityTracker.setResult(
    false,
    {
      documentEverHidden: getDocumentHiddenResult(documentHiddenTrackerId, true)! > -1,
      devToolEverOpened: isDevToolEverOpenedInCurrentWindow(),
      isOffline: !window.navigator.onLine
    } /**additionalProps */,
    error
  );

  logger &&
    logQoSError(
      logger,
      Activity.LoadComponentInIframe,
      OWHAshaPillar.Open,
      OWHAshaVeto.FileOpenFailed,
      OWHAshaErrorType.IframeTimeoutFailure,
      {} /*additionalProps*/,
      error
    );

  reject(error);
}

// cspell:ignore Asha
